import React from "react";

import DummyAgentImage from "../../images/DummyAgent.svg";
import { s360ConfigService } from "../Services/S360Config";

import "../LandingPage/LandingPageStyleSheet.css";
import {
  DATA_TEST_ID_PREFIX,
  DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA,
  LIVECHAT_CLICK_EVENTS,
} from "../../utils/Constants/statsig.constants";
function LandingPageHeader(props) {
  const onClose = () => {
    props.actions &&
      props.actions.onHideChatWindow &&
      props.actions.onHideChatWindow();
    props.actions.onStartUpClick();
  };

  return (
    <div
      className="s360-landing-page-header"
      style={props.config?.customDesign?.landingPageHeader}
    >
      <div
        className="s360-landing-page-header-titles"
        style={props.config?.customDesign?.landingPageHeaderSalutationMessage}
      >
        <div className="s360-landing-page-header-text">
          <span>{s360ConfigService.config.configDetails?.header}</span>
        </div>
        <div className="s360-landing-page-header-subheader-container">
          {s360ConfigService?.config?.configDetails?.showAgentInfo &&
            s360ConfigService?.config?.configDetails.showAgentImage && (
              <div
                className={`s360-conversation-header-details-image${
                  localStorage.getItem("openInFullScreen") ? "-fs" : ""
                }`}
              >
                <img
                  src={
                    s360ConfigService?.config?.configDetails?.brandIcon ||
                    DummyAgentImage
                  }
                  alt="/"
                  style={{ width: "100%" }}
                />
              </div>
            )}
          <div
            className="s360-landing-page-header-information"
            style={props.config?.customDesign?.landingPageHeaderInformation}
          >
            {s360ConfigService.config.configDetails?.agentIndroductionMessage}
          </div>
        </div>
        {/*<div className="s360-default-header-icon" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.624"
            height="53"
            viewBox="0 0 13.624 8.209"
          >
            <path
              id="down-arrow"
              d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
              transform="translate(-2364.171 -5054.96)"
              style={props.config?.customDesign?.defaultHeaderIcon}
            />
          </svg>
        </div>*/}
      </div>
    </div>
  );
}

export default LandingPageHeader;
